<template>
    <div class="flex items-center justify-center">
      <nuxt-img format="webp" :src="qr_raw" />
    </div>
  </template>
  
  <script setup lang="ts">
  import QRCode from 'qrcode'
  
  const props = defineProps({
    url: String
  })

  
  const qr_raw = await QRCode.toDataURL(props.url || '')
    .catch((err) => {
      console.error('[Qr] Failed to generate QR:', err)
      return ''
    })
  
  </script>